module.exports = __webpack_public_path__ + "img/03.2fb7cc47.png";